import "@/App.css";
import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import PageMeta from "@/components/PageMeta";
import Home from "@/pages/Home";
import Bitumen from "@/pages/Bitumen";
import Lubricants from "@/pages/Lubricants";
import Petrochemicals from "@/pages/Petrochemicals";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminInbox from "@/pages/AdminInbox";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App min-h-screen bg-navy text-white">
      <BrowserRouter>
        <ScrollToTop />
        <PageMeta />
        <Header />
        <div className="h-24" aria-hidden="true" />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/bitumen" element={<Bitumen />} />
            <Route path="/lubricants" element={<Lubricants />} />
            <Route path="/petrochemicals" element={<Petrochemicals />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminInbox />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}
